import { useSnapshot } from 'valtio';
import { activeModalStack, hideCurrentModal } from '../globalState';
import OptionsGroup from './OptionsGroup';
import { useIsModalActive } from './utilsApp';
export default () => {
    useIsModalActive('options-*');
    const { reactType } = useSnapshot(activeModalStack).at(-1) ?? {};
    if (!reactType?.startsWith('options-'))
        return;
    const settingsGroup = reactType.slice('options-'.length);
    return <OptionsGroup group={settingsGroup} backButtonAction={hideCurrentModal}/>;
};
